import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Link,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useNavigate } from "react-router-dom";

interface AlertDialogBoxProps {
  open: boolean;
  onClose: () => void;
}

const AlertDialogBox = ({ open, onClose }: AlertDialogBoxProps) => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
        },
      }}
    >
      {/* Close */}
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "#9E9E9E",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        {/* Icon */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <WarningAmberIcon
            sx={{
              fontSize: 40,
              color: "text",
            }}
          />
        </Box>

        {/* Title */}
        <Typography fontSize={16} fontWeight={600} textAlign="center" mb={1}>
          Action Required
        </Typography>

        {/* Message (same text) */}
        <Typography
          fontSize={14}
          color="text.secondary"
          textAlign="center"
          lineHeight={1.6}
        >
          Please update your Profile details to meet the requirements for this
          application. Ensure that your Applicant Type is set to “Organisation”
          and that your valid GST Number is added, wherever applicable.{" "}
          <Button
            className="btn btn-primary"
            component="button"
            onClick={() => {
              onClose();
              navigate("/view-profile");
            }}
            sx={{
              fontWeight: 500,
              color: "#fff",
              bgcolor: "#3a1c73",
              mt: 0.7,
              px: 1.5,
              py: 0.75,
              borderRadius: "20px",
            }}
          >
            Update Profile
          </Button>{" "}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default AlertDialogBox;
